import { render, staticRenderFns } from "./Dinners.vue?vue&type=template&id=78a5cd90&scoped=true"
import script from "./Dinners.vue?vue&type=script&lang=js"
export * from "./Dinners.vue?vue&type=script&lang=js"
import style0 from "./Dinners.vue?vue&type=style&index=0&id=78a5cd90&prod&lang=css"
import style1 from "./Dinners.vue?vue&type=style&index=1&id=78a5cd90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a5cd90",
  null
  
)

export default component.exports